module.exports = __webpack_public_path__ + "img/erro.c71438fa.png";